module.exports = __webpack_public_path__ + "media/images/provider-audio-active-4bc73fdf80312255fed69ee2720f57824394a0a07b531243591d66d7a1447707.svg";